import classNames from 'classnames';
import { useRef } from 'react';
import { CustomTableProps } from '../../interfaces';
import '../../styles.scss';
import useLoadingRow from './hooks/useLoadingRow';
import { TableWrapper } from './styles';
import './styles/index.scss';
import { useMobile } from '../../hooks/useMobile';
import CardTable from './Card';

export const CustomTable: React.FC<CustomTableProps> = props => {
  const {
    className,
    dataSource,
    onCardClick,
    bordered = false,
    pagination = false,
    isSortColumns = false,
    whiteBackground = false,
    horizontalBorder = false,
    columns: unfilteredColumns = [],
    ...rest
  } = props;

  const isMobile = useMobile();

  const columns = unfilteredColumns?.filter(column => column.show !== false);

  const columnsTable = isSortColumns
    ? columns?.sort((a, b) => Number(a?.key) - Number(b?.key))
    : columns;

  const tableRef = useRef<HTMLDivElement>(null);
  useLoadingRow(tableRef, dataSource);

  return isMobile ? (
    <CardTable
      data={dataSource ?? []}
      onCardClick={onCardClick}
      isLoading={!!rest.loading}
      columns={unfilteredColumns}
    />
  ) : (
    <TableWrapper
      {...rest}
      ref={tableRef}
      bordered={bordered}
      columns={columnsTable}
      dataSource={dataSource}
      pagination={pagination}
      className={classNames(className, 'custom-table', {
        'white-background': whiteBackground,
        'horizontal-border': horizontalBorder,
      })}
    />
  );
};

export default CustomTable;
